import React from 'react'
import UserNav from '../UserComponents/UserNav'
import UserSidebar from '../UserComponents/UserSidebar'
import UserProjectTable from '../UserComponents/UserProjectTable'

const ProjectList = () => {
  return (
     <div style={{ background: 'rgb(255, 255, 255)', height: '100vh' }}>
      <div className='flex'>
        <div>
          <UserSidebar />
        </div>
          <div className='w-full'>
          <UserNav />
                      <UserProjectTable />

          </div>
      </div>
    </div>
  )
}

export default ProjectList
